import Vue from 'vue';
import {
  addGroupingInResponseData,
  LinkCellRenderer,
  autoResize,
  MultiLinkCellRenderer,
  ProgressBarRenderer,
  getPinnedRowData
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  handlerResponse,
  SumRows
} from '@/helpers/commonHelpers';
import gridProps from '@/gridProps';

export default {
  namespaced: true,
  state: {
    columns: [],
    progressPerMovementColumns: [
      {field: "movement_name", colId: "movement_name", headerName: "Acceptance No.", cellRenderer: "MovementLink"},
      {field: "contract_nr", colId: "contract_nr", headerName: "Contract", cellRenderer: "ContractLink"},
      {
        headerName: "Delivered", children: [
        {field: "delivered_nominal", colId: "delivered_nominal", headerName: "nom"},
        {field: "delivered_stock", colId: "delivered_stock", headerName: "stock"}]
      },
      {field: "measure_type", colId: "measure_type", headerName: "UoM"}
    ],
    purchaseOrders: [],
    pinnedRowData: [],
    ordersCount: 0,
    documents: [],
    comments: [],
    progressPerMovement: [],
    gridOptions: {
      rowGroupPanelShow: 'always',
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      aggFuncs: {
        'SumRows': SumRows
      },
      components: {
        'ContractLink': LinkCellRenderer('contract_id', '/contracts/'),
        'ContractsLink': MultiLinkCellRenderer('contracts', '/contracts/', 'contract_nr', 'id'),
        'ProgressBar': ProgressBarRenderer()
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      }
    },
    gridName: ''
  },
  getters: {
    gridOptions(state) {
      return {
        ...state.gridOptions,
        ...gridProps,
        components: {
          'PurchaseOrderLink': LinkCellRenderer('id', '/purchaseOrders/'),
          'BuyerLink': LinkCellRenderer('buyer_id', '/partners/'),
          'SupplierLink': LinkCellRenderer('shipper_id', '/partners/'),
          'AgentLink': LinkCellRenderer('agent_id', '/partners/'),
          'ContractsLink': MultiLinkCellRenderer('contracts', '/contracts/', 'contract_nr', 'id')
        }
      };
    },
    progressPerMovementGridOptions(state) {
      return {
        ...state.gridOptions,
        rowGroupPanelShow: 'never',
        components: {
          'ContractLink': LinkCellRenderer('contract_id', '/contracts/'),
          'MovementLink': LinkCellRenderer('movement_id', '/operation/'),
        }
      };
    }
  },
  mutations: {
    setData(state, data) {
      if (data.data) {
        state.columns = addColIdToColumns(data.used_columns);
        //adding unique keys for 'contract_nr' column. Needed for correct row grouping
        state.columns = state.columns.map(e => {
          if (e.field && e.field === 'contracts') {
            e.keyCreator = function (params) {
              if (params) {
                return params.value.map(e => e.id).join('');
              }
            }
          }
          return e
        });
        state.purchaseOrders = addGroupingInResponseData(data.data.results);
        state.ordersCount = data.data.count;
        state.pinnedRowData = getPinnedRowData(data.total, 'name', 'value');
      }
      else {
        state.purchaseOrders = data;
        state.pinnedRowData = data;
      }
      if (data.grid_name) {
        state.gridName = data.grid_name;
      }
    },
    setProgressPerMovementData(state, data) {
      state.progressPerMovement = data;
    },
    setCommentsList(state, data) {
      state.comments = data;
    },
    setDocumentsList(state, data) {
      state.documents = data;
    }
  },
  actions: {
    loadPurchaseOrders(store, payLoad) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('purchase/search_for_orders/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setData', data);
        });
    },
    loadBindedMovementProgress(store, payLoad) {
      Vue.http.get(`purchase/orders/${payLoad.id}/progress_per_movement/`, {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setProgressPerMovementData', data);
        });
    },
    loadCommentsList(store, payLoad) {
      Vue.http.get(`purchase/orders/${payLoad.id}/comments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setCommentsList', data);
        });
    },
    loadDocumentsList(store, payLoad) {
      Vue.http.get(`purchase/orders/${payLoad.id}/attachments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setDocumentsList', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/purchases/orders/purchaseOrders.js